import { ROUTES_STADISTICS } from '@app/modules/stadistics/enums/routes-stadistics';
import { ROUTES_DASHBOARD } from '../../enums/routes-dashboard.enum';
import { IMenuSection } from '@common/interfaces/generic/menu.interface';
import { ROUTES_MANAGER } from '@app/modules/management/enums/routes.enum';
import { ROUTES_LIQUIDACIONES } from '@app/modules/liquidaciones/enums/routes-liquidaciones.enum';

export const menuOptions: IMenuSection[] = [
  {
    section: "Inicio",
    active: true,
    options: [
      {
        label: "Estadísticos",
        active: true,
        icon: "fa-solid fa-chart-simple",
        permission: "stadistics:main",
        link: [ROUTES_DASHBOARD.STADISTICS, ROUTES_STADISTICS.STADISTICS]
      },
      {
        label: "Mi día",
        active: true,
        icon: "fa-solid fa-chart-simple",
        permission: "stadistics:my-day",
        link: [ROUTES_DASHBOARD.STADISTICS, ROUTES_STADISTICS.MY_DAY]
      },
      {
        label: "Mi oficina",
        active: true,
        icon: "fa-solid fa-chart-simple",
        permission: "stadistics:my-office",
        link: [ROUTES_DASHBOARD.STADISTICS, ROUTES_STADISTICS.MY_OFFICE]
      },
      {
        label: "Ranking",
        active: false,
        icon: "fa-solid fa-ranking-star",
        link: ""
      }
    ]
  },
  {
    section: "Operación",
    active: true,
    options: [
      {
        label: "Prospección",
        active: true,
        icon: "fa-solid fa-person-dots-from-line",
        link: [ROUTES_DASHBOARD.PROSPECTION],
        permission: "prospection:view"
      },
      {
        label: "Contratos",
        active: true,
        icon: "fa-solid fa-file-invoice-dollar",
        permission: "contracts:view",
        link: [ROUTES_DASHBOARD.CONTRACTS]
      },
      {
        label: "Objetivos",
        active: false,
        icon: "fa-solid fa-list-check",
        link: [ROUTES_DASHBOARD.OPERATIONS]
      },
      {
        label: "Equipos",
        active: true,
        permission: "teams:view",
        icon: "fa-solid fa-people-group",
        link: [ROUTES_DASHBOARD.TEAMS]
      }
    ]
  },
  {
    section: "Administración",
    active: true,
    options: [
      {
        label: "Campañas prospección",
        active: true,
        permission: "campaigns:view",
        icon: "fa-solid fa-square-phone",
        link: [ROUTES_DASHBOARD.MANAGEMENT, ROUTES_MANAGER.CAMPAINGS]
      },
      {
        label: "Reportes proveedores",
        active: true,
        permission: "provider_reports:view",
        icon: "fa-solid fa-file-contract",
        link: [ROUTES_DASHBOARD.MANAGEMENT, ROUTES_MANAGER.PROVIDER_REPORTS]
      },
      {
        label: "Liquidaciones",
        active: true,
        permission: "liquidations:view",
        icon: "fa-solid fa-file-invoice",
        link: [ROUTES_DASHBOARD.LIQUIDATIONS]
      }
    ]
  },
  {
    section: "Herramientas",
    active: true,
    options: [
      {
        label: "Prueba de Servicios",
        active: true,
        permission: "services:test_sms_status",
        icon: "fa-solid fa-vial-circle-check",
        link: [ROUTES_DASHBOARD.TOOLS]
      }
    ]
  },
  {
    section: "Sistema",
    active: true,
    options: [
      {
        label: "Usuarios",
        active: true,
        permission: "users:view",
        icon: "fa-solid fa-users",
        link: [ROUTES_DASHBOARD.USERS]
      },
      {
        label: "Oficinas",
        active: true,
        permission: "offices:view",
        icon: "fa-solid fa-building",
        link: [ROUTES_DASHBOARD.OFFICES]
      }
    ]
  }
];
